const constants = {
    intervals: {
        // need to refetch often to update minutes left from pickupTime
        FULL_RESYNC_INTERVAL: 60 * 1000, // 1 minute
        RECONNECT_TIMEOUT: 15 * 1000, // 15 seconds
        RECONNECT_INTERVAL: 45 * 1000, // 45 seconds
    },
    cutoffs: {
        EXPIRED_ORDER: 12 * 60, // 12 minutes (amount of time before overdue order is removed from screen)
    },
    debugSerial: 'tty-nyn-aab26', // 'POSDEBUG',
    debugShortId: 'ABCDE',
    restaurantDashboardSnackTvURL: 'https://dashboard.snackpass.co/snack-tv',
    cloudinaryCloud: 'ddhetmqtt',
};

export default constants;
